/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from '../BaseCom';
import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import { css } from '@codemirror/lang-css';


export default class CodeEditor extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    componentDidMount() {
        this.setState({ value: this.props.value });
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value });
        }
    }

    render() {
        return (
            <div style={{ position: 'relative', height: this.props.height ?? 'auto' }}>
                <CodeMirror value={this.state.value} height={this.props.height} extensions={[this.props.lang === 'css' ? css() : html()]} theme={this.props.theme ?? 'light'}
                    onChange={(value) => this.props.onChange?.(value)} />
            </div>
        );
    }
}
